<template>
  <nav
    v-if="current_project"
    id="secondarybar"
    class="bg-secondary-color flex h-12 min-w-0 items-center"
    data-test="navbar-desktop-topbar"
    style="background-color: var(--surface-light); border-bottom: 1px solid var(--secondary-500)"
    :aria-label="$t('navbar.landmarks.employee.client.secondary')"
  >
    <a
      class="flex min-w-0 shrink items-center gap-2 pl-4"
      style="height: 100%"
      @click="SHOW_PROJECT_SIDEBAR(true)"
    >
      <span
        v-if="current_project.attributes.skip_customer"
        class="template-icon-container-large"
      >
        <FontAwesomeIcon
          :icon="['far', 'memo']"
          class="text-gray-500"
          size="md"
        />
      </span>
      <Avatar
        v-else
        :src="current_project.attributes.picture_login_url_s"
        :username="current_project.attributes.name"
        class="min-w-7.5"
        size="30"
      />
      <span class="truncate">{{ current_project.attributes.name }}</span>
    </a>

    <div class="topbar-divider" />

    <div
      v-if="mq.isDesktop"
      class="flex shrink-0 items-center gap-3 pr-2"
    >
      <NavbarItemHorizontal
        v-for="(item, idx) in routesActive"
        :key="idx"
        :item="item"
        :params="params"
      />
    </div>

    <div v-else>
      <div
        class="cursor-pointer p-2 hover:text-gray-500"
        @click="toggle"
      >
        <FontAwesomeIcon
          :icon="['far', 'bars']"
          size="lg"
        />
      </div>

      <PMenu
        id="overlay_menu"
        ref="menu"
        :model="routesActive"
        :popup="true"
      >
        <template #item="{ item, props }">
          <NavbarItemHorizontal
            :item="item"
            :params="params"
            v-bind="props.action"
          />
        </template>
      </PMenu>
    </div>
  </nav>
</template>

<script>
import { useMqService } from '@/plugins/mq';
import { NAVBAR_ITEMS_EMPLOYEES_SECONDARY_NAVBAR } from '@/app/data/navbar_constants';
import NavbarItemHorizontal from '@/app/shared_components/navbar/NavbarItemHorizontal.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TheNavbarDesktopClientHorizontalSecondary',
  components: {
    NavbarItemHorizontal,
  },

  setup() {
    const mq = useMqService();
    return { mq };
  },

  computed: {
    ...mapGetters(['current_client', 'current_project']),

    routesActive() {
      return _.filter(NAVBAR_ITEMS_EMPLOYEES_SECONDARY_NAVBAR, this.isRouteActive);
    },
    level() {
      return this.current_project.attributes.skip_unit ? this.current_level : this.current_project;
    },
    params() {
      return {
        project_id: this.current_project.id,
        level_type: _.get(this.level, 'type'),
        level_id: _.get(this.level, 'id'),
      };
    },
  },

  methods: {
    ...mapActions(['SHOW_PROJECT_SIDEBAR']),
    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    isRouteActive(route) {
      if (!this.isFlipperEnabled(route)) {
        return false;
      }

      return !this.current_project.attributes.skip_customer || !route.hidden_skip_customer;
    },

    isFlipperEnabled(route) {
      return !route.flipper || this.$flipper.enabled(route.flipper);
    },
  },
};
</script>
